function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M36.55 3.33l1.86 1.86c.44.43.44 1.15 0 1.59L21.47 23.76l16.94 16.98c.44.44.44 1.15 0 1.6l-1.86 1.85c-.44.44-1.15.44-1.59 0L15.33 24.55a1.13 1.13 0 010-1.59L34.96 3.33a1.12 1.12 0 011.6 0z"
})));